// extracted by mini-css-extract-plugin
module.exports = {"separator":"ShiftCashierSeparator_separator__Yi-kg"};